import { GetCustomerInvoicesQuery } from '../../graphql/camel'
import { monthDayYear } from '../../utils/dateTools'
import { formatAsCurrencyOrZero } from '../../utils/priceTools'

type CustomerInvoice = NonNullable<
  GetCustomerInvoicesQuery['getCustomerInvoices']
>['invoices'][number]

interface ExportInvoiceData {
  date: string
  invoiceNumber: string
  total: string
}

export const csvDataFromInvoices = (invoices: CustomerInvoice[]): ExportInvoiceData[] =>
  invoices.reduce((acc: ExportInvoiceData[], invoice) => {
    if (!invoice) {
      return acc
    }
    acc.push({
      date: monthDayYear(invoice.date),
      invoiceNumber: `#${invoice.invoiceNumber}`,
      total: formatAsCurrencyOrZero({ amount: invoice.total }),
    })
    return acc
  }, [])
